class AdventCalendar {
  constructor() {
    this.modal = document.getElementById('advent-modal');
    this.modalOverlay = this.modal?.querySelector('.advent-modal-overlay');
    this.modalClose = this.modal?.querySelector('.advent-modal-close');
    this.doors = document.querySelectorAll('.advent-door');
    
    this.init();
  }

  init() {
    if (!this.modal) return;

    this.bindEvents();
    
    setInterval(() => this.updateCountdowns(), 1000);
  }

  bindEvents() {
    const triggers = document.querySelectorAll('[data-modal-trigger]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openModal(trigger);
      });
      
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.openModal(trigger);
        }
      });
    });

    this.modalClose?.addEventListener('click', () => this.closeModal());
    this.modalOverlay?.addEventListener('click', () => this.closeModal());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal?.classList.contains('active')) {
        this.closeModal();
      }
    });

    const copyButtons = this.modal?.querySelectorAll('.advent-copy-code');
    copyButtons?.forEach(btn => {
      btn.addEventListener('click', () => this.copyDiscountCode(btn));
    });
  }

  openModal(trigger) {
    const productTitle = trigger.dataset.productTitle;
    const productUrl = trigger.dataset.productUrl;
    const productImage = trigger.dataset.productImage;
    const productPrice = trigger.dataset.productPrice;
    const productComparePrice = trigger.dataset.productComparePrice;
    const discountCode = trigger.dataset.discountCode;

    const modalTitle = this.modal.querySelector('.advent-modal-title');
    const modalImage = this.modal.querySelector('.advent-modal-image');
    const modalPrice = this.modal.querySelector('.advent-modal-price');
    const ctaButton = this.modal.querySelector('.advent-cta-button');
    const discountSection = this.modal.querySelector('.advent-discount-section');
    const discountValue = this.modal.querySelector('.advent-discount-value');
    const countdownSection = this.modal.querySelector('.advent-countdown');
    const countdownTimer = this.modal.querySelector('.advent-countdown-timer');

    if (modalTitle) modalTitle.textContent = productTitle;
    
    if (modalImage) {
      modalImage.innerHTML = productImage 
        ? `<img src="${productImage}" alt="${productTitle}" loading="lazy">`
        : '';
    }

    if (modalPrice) {
      let priceHtml = `<span class="price">${productPrice}</span>`;
      if (productComparePrice && productComparePrice !== productPrice) {
        priceHtml += `<span class="compare-price">${productComparePrice}</span>`;
      }
      modalPrice.innerHTML = priceHtml;
    }

    if (discountCode && discountSection && discountValue) {
      discountValue.textContent = discountCode;
      discountSection.style.display = 'block';
      
      if (ctaButton && productUrl) {
        const url = new URL(productUrl, window.location.origin);
        url.searchParams.set('discount', discountCode);
        ctaButton.href = url.toString();
      }
    } else {
      if (discountSection) discountSection.style.display = 'none';
      if (ctaButton) ctaButton.href = productUrl;
    }

    if (countdownSection) {
      countdownSection.style.display = 'none';
    }

    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';

    this.modal.querySelector('.advent-modal-content')?.focus();
  }

  closeModal() {
    this.modal?.classList.remove('active');
    document.body.style.overflow = '';
  }

  async copyDiscountCode(button) {
    const codeElement = button.closest('.advent-discount-code')?.querySelector('.advent-discount-value');
    const code = codeElement?.textContent;
    
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
      
      const originalText = button.textContent;
      const copiedText = button.dataset.copiedText || 'Copied!';
      
      button.textContent = copiedText;
      button.classList.add('copied');
      
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('copied');
      }, 2000);
    } catch (err) {
      console.error('Failed to copy discount code:', err);
      
      const input = document.createElement('input');
      input.value = code;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      
      const originalText = button.textContent;
      button.textContent = button.dataset.copiedText || 'Copied!';
      button.classList.add('copied');
      
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('copied');
      }, 2000);
    }
  }

  updateCountdowns() {
    const timers = document.querySelectorAll('.advent-countdown-timer[data-expires]');
    timers.forEach(timer => this.updateCountdown(timer));
  }

  updateCountdown(timer) {
    const expires = timer.dataset.expires;
    if (!expires) return;

    const expiresDate = new Date(expires);
    const now = new Date();
    const diff = expiresDate - now;

    if (diff <= 0) {
      timer.textContent = 'Offer expired';
      timer.closest('.advent-countdown')?.style.setProperty('opacity', '0.5');
      return;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const pad = (num) => String(num).padStart(2, '0');
    timer.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new AdventCalendar());
} else {
  new AdventCalendar();
}